export default __webpack_public_path__ + "static/media/riverwalk_cement.0b80570e.jpg";